export default __webpack_public_path__ + "4bbf16573b4066b8583dab1374d64b5a.svg";